common = require('../common')
Link = require('react-router-dom').Link

module.exports = class ReplicationRollEditable extends React.Component
  displayName: 'ReplicationRollEditable'

  constructor: (props) ->
      super(props)
      # expects @props.replication
      # @props.editor
      if @props.replication.replication
          replication = @props.replication.replication
          repl_jn = @props.replication.replicate_junction
      else
          replication = @props.replication[0]
          repl_jn = @props.replication[1]
      if replication.replicable_id
          # This is a ZDZ link
          link_mode = 'ZDZ'
          link = replication.replicable_url
      else
          # This is an offsite link
          link_mode = 'offsite'
          link = replication.replicable_url
      @state = {
        mode: 'display'
        delete_state: 'show_delete'
        replication: replication
        link: link
        link_mode: link_mode
        repl_jn: repl_jn
      }

  componentDidMount: =>

    if @props.editor is 'MathJax'
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, @domElement])

    setDOMRef: (domElement) =>
      @domElement = domElement

  goToLink: () =>
      link = @state.link
      pre_link = link.slice(0,4)
      if pre_link is 'http'
          window.open(link)
      else
          window.open('http://' + link)

  removeReplicationFromObject: () =>

      data =
        replicate_junction_id : @state.repl_jn.id

      common.hideReplication(data, (result) =>
         @setState({ mode: 'removed' })
      )

  askIfSureBeforeDelete: () =>
      @setState({ delete_state: 'ask_if_sure'})

  render: =>

      if @state.delete_state is 'show_delete'
          delete_button =
              <button className="btn btn-danger btn-txt-sm"
                      onClick={@askIfSureBeforeDelete}>
                      delete</button>
      else
          delete_button =
              <button className="btn btn-danger btn-txt-sm"
                      onClick={@removeReplicationFromObject}>
                      Are you sure?</button>

      if @state.link_mode is 'ZDZ'
          title_text =
              <Link to={@state.link}>
                  <span>{ @state.replication.title }</span>
              </Link>
      else
          title_text =
              <span>{ @state.replication.title }</span>
          if @state.link.length > 50
              url_text = @state.link.slice(0,50) + '...'
          else
              url_text = @state.link
          offsite_link_row =
              <div className='row no-gutters'>
                  <div className='col-xs-2 col-sm-2 col-md-2 col-lg-2'>
                      Offsite Link:
                  </div>
                  <div className='col-xs-10 col-sm-10 col-md-10 col-lg-10'>
                      <button className='btn btn-link btn-sm m-0 p-0 truncate'
                              onClick={@goToLink}>{ url_text }</button>
                  </div>
              </div>

      if @props.editor is 'MathJax'
          just_the_facts =
              <span className='mathjax new_lines_enabled'
                    ref={@setDOMRef}
                    dangerouslySetInnerHTML={{__html: @state.replication.facts }}>
              </span>
      else
          just_the_facts =
              <span className='new_lines_enabled'
                    dangerouslySetInnerHTML={{__html: @state.replication.facts }}>
              </span>

      if @state.replication.recommend is 1
          recommendation = 'Yes'
      else
          recommendation = 'No'


      if @state.mode is 'removed'
          <div className='row no-gutters m-3 border border-success'>
              Bye-bye!
          </div>
      else
          <div className='col border rounded success m-3 border-success'>
              <div className='row no-gutters'>
                  <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      Replicated:&nbsp;{ title_text }
                      <div>
                          { delete_button }
                      </div>
                  </div>
              </div>
              { offsite_link_row }
              <div className='row no-gutters'>
                  <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      Facts:&nbsp;{ just_the_facts }
                  </div>
              </div>
              <div className='row no-gutters'>
                  <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                      Overall recommended? { recommendation }
                  </div>
              </div>
          </div>
